export default __webpack_public_path__ + "static/easy_to_use_mm_spring.png";